export const getUserName = user => {
  const { given_name: givenName, family_name: familyName, name = "" } = user;
  const userName = givenName && familyName ? `${givenName} ${familyName}` : name;
  return userName;
};



// WEBPACK FOOTER //
// ./src/helpers/userHelpers.js